<template>
  <div>
    <!--        <div class="head">
                <el-button type="primary" size="small" style="width: 80px" @click="addBtn">新增</el-button>
            </div>-->
    <div class="app-container">
      <el-table :data="dataConfigurationList"
                :header-cell-style="{ background: 'rgb(250,250,250)' }"
                style="width: 100%">
        <el-table-column label="企业标识" align="center" prop="enterpriseId"/>
        <el-table-column label="风险分析对象编码即危险源编码" align="center" prop="riskobjectCode"/>
        <el-table-column label="风险四色图授权码" align="center" prop="safechartSqkey"/>
        <el-table-column label="危险源授权码" align="center" prop="dangersrcSqkey"/>
        <el-table-column label="风险分析对象授权码" align="center" prop="riskObjectSqkey"/>
        <el-table-column label="风险分析单元授权码" align="center" prop="riskUtilSqkey"/>
        <el-table-column label="安全风险信息授权码" align="center" prop="riskInfoSqkey"/>
        <el-table-column label="安全风险辨识授权码" align="center" prop="riskDistSqkey"/>
        <el-table-column label="安全风险管控措施授权码" align="center" prop="riskCtrlSqkey"/>
        <el-table-column label="隐患排查任务授权码" align="center" prop="hdCheckplanSqkey"/>
        <el-table-column label="隐患排查记录授权码" align="center" prop="hdCheckrecordSqkey"/>
        <el-table-column label="隐患排查治理台账授权码" align="center" prop="hiddendangerInfoSqkey"/>
        <el-table-column label="装置停用/检维修授权码" align="center" prop="riskUnitStopSqkey"/>
        <el-table-column label="专项检查任务信息授权码" align="center" prop="checkTaskSqKey"/>
        <el-table-column label="专项检查项授权码" align="center" prop="checkItemSqKey"/>
        <el-table-column label="专项检查评分细则授权码" align="center" prop="checkScoreSqKey"/>
        <el-table-column label="专项检查隐患信息授权码" align="center" prop="specialDangerSqKey"/>
        <el-table-column label="专项检查情况记录授权码" align="center" prop="specialCheckrecordSqkey"/>
        <el-table-column label="操作" width="120">
          <template slot-scope="{ row }">
            <span class="btn" style="color: #1890ff" @click="editBtn(row)">编辑</span>
            <span style="margin: 0 5px;color: #e8e8e8">|</span>
            <span class="btn" style="color: #ff0000" @click="deleteBtn(row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 15px">
        <Page :total="total" :current="curPage" :page-size="pageSize" @on-change="pageChange"/>
      </div>
    </div>


    <!-- 添加或修改上传信息配置对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="180px">
        <el-form-item label="企业标识" prop="enterpriseId">
          <el-input v-model="form.enterpriseId" placeholder="请输入企业标识"/>
        </el-form-item>
        <el-form-item label="风险分析对象编码" prop="riskobjectCode">
          <el-input v-model="form.riskobjectCode" placeholder="即危险源编码"/>
        </el-form-item>
        <el-form-item label="风险四色图授权码" prop="safechartSqkey">
          <el-input v-model="form.safechartSqkey" type="textarea" placeholder="请输入内容"/>
        </el-form-item>
        <el-form-item label="危险源授权码" prop="dangersrcSqkey">
          <el-input v-model="form.dangersrcSqkey" type="textarea" placeholder="请输入内容"/>
        </el-form-item>
        <el-form-item label="风险分析对象授权码" prop="riskObjectSqkey">
          <el-input v-model="form.riskObjectSqkey" type="textarea" placeholder="请输入内容"/>
        </el-form-item>
        <el-form-item label="风险分析单元授权码" prop="riskUtilSqkey">
          <el-input v-model="form.riskUtilSqkey" type="textarea" placeholder="请输入内容"/>
        </el-form-item>
        <el-form-item label="安全风险信息授权码" prop="riskInfoSqkey">
          <el-input v-model="form.riskInfoSqkey" type="textarea" placeholder="请输入内容"/>
        </el-form-item>
        <el-form-item label="安全风险辨识授权码" prop="riskDistSqkey">
          <el-input v-model="form.riskDistSqkey" type="textarea" placeholder="请输入内容"/>
        </el-form-item>
        <el-form-item label="安全风险管控措施授权码" prop="riskCtrlSqkey">
          <el-input v-model="form.riskCtrlSqkey" type="textarea" placeholder="请输入内容"/>
        </el-form-item>
        <el-form-item label="隐患排查任务授权码" prop="hdCheckplanSqkey">
          <el-input v-model="form.hdCheckplanSqkey" type="textarea" placeholder="请输入内容"/>
        </el-form-item>
        <el-form-item label="隐患排查记录授权码" prop="hdCheckrecordSqkey">
          <el-input v-model="form.hdCheckrecordSqkey" type="textarea" placeholder="请输入内容"/>
        </el-form-item>
        <el-form-item label="隐患排查治理台账授权码" prop="hiddendangerInfoSqkey">
          <el-input v-model="form.hiddendangerInfoSqkey" type="textarea" placeholder="请输入内容"/>
        </el-form-item>
        <el-form-item label="装置停用/检维修授权码" prop="riskUnitStopSqkey">
          <el-input v-model="form.riskUnitStopSqkey" type="textarea" placeholder="请输入内容"/>
        </el-form-item>
        <el-form-item label="专项检查任务信息授权码" prop="checkTaskSqKey">
          <el-input v-model="form.checkTaskSqKey" type="textarea" placeholder="请输入内容"/>
        </el-form-item>
        <el-form-item label="专项检查项授权码" prop="checkItemSqKey">
          <el-input v-model="form.checkItemSqKey" type="textarea" placeholder="请输入内容"/>
        </el-form-item>
        <el-form-item label="专项检查评分细则授权码" prop="checkScoreSqKey">
          <el-input v-model="form.checkScoreSqKey" type="textarea" placeholder="请输入内容"/>
        </el-form-item>
        <el-form-item label="专项检查隐患信息授权码" prop="specialDangerSqKey">
          <el-input v-model="form.specialDangerSqKey" type="textarea" placeholder="请输入内容"/>
        </el-form-item>
        <el-form-item label="专项检查情况记录授权码" prop="specialCheckrecordSqkey">
          <el-input v-model="form.specialCheckrecordSqkey" type="textarea" placeholder="请输入内容"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addDataConfiguration,
  delDataConfiguration,
  getDataConfiguration,
  listDataConfiguration,
  updateDataConfiguration
} from "@/api/doublePrevention/dataConfiguration";

export default {
  name: "DataConfiguration",
  data() {
    return {
      // 上传信息配置表格数据
      dataConfigurationList: [],
      total: 0,
      curPage: 1,
      pageSize: 10,
      open: false,
      form: {},
      rules: {},
      title: null
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询上传信息配置列表 */
    getList() {
      listDataConfiguration({limit: this.pageSize, curPage: this.curPage, type: 0, isPage: 1}).then(res => {
        this.dataConfigurationList = res.body.data;
        this.total = res.body.cum
      });
    },
    pageChange(val) {
      this.curPage = val;
      this.getList();
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: 0,
        enterpriseId: null,
        riskobjectCode: null,
        safechartSqkey: null,
        dangersrcSqkey: null,
        riskObjectSqkey: null,
        riskUtilSqkey: null,
        riskInfoSqkey: null,
        riskDistSqkey: null,
        riskCtrlSqkey: null,
        hdCheckplanSqkey: null,
        hdCheckrecordSqkey: null,
        hiddendangerInfoSqkey: null,
        riskUnitStopSqkey: null,
        checkTaskSqKey: null,
        checkItemSqKey: null,
        checkScoreSqKey: null,
        specialDangerSqKey: null,
        specialCheckrecordSqkey: null,
      };
//                this.resetForm("form");
    },
    /** 新增按钮操作 */
    addBtn() {
      this.reset();
      this.open = true;
      this.title = "添加上传信息配置";
    },
    /** 修改按钮操作 */
    editBtn(row) {
      this.reset();
      const id = row.id
      getDataConfiguration(id).then(response => {
        this.form = response.body.data;
        this.open = true;
        this.title = "修改上传信息配置";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            updateDataConfiguration(this.form).then(response => {
              this.$Message.success('修改成功');
              this.open = false;
              this.getList();
            });
          } else {
            addDataConfiguration(this.form).then(response => {
              this.$Message.success('新增成功');
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    deleteBtn(row) {
      const id = row.id
      delDataConfiguration(id).then(res => {
        this.$message.success('删除成功')
        this.getList()
      })
    }
  }
};
</script>
